import { getJsonOrError } from './../../utils/fetch'

export class UserProxy {
  impersonate = to => getJsonOrError(`/admin/impersonate?id=${to}`, { credentials: 'include' })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/user/index.js